export default {
    direction: 'ltr',
    palette: {
        type: 'dark',
        primary: {
            main: '#051f4e'
        },
        secondary: {
            main: '#e3e6eb'
        },

    },
};